import constate from "constate";
import { get } from "lodash";
import { useEffect } from "react";
import i18next from "i18next";

export const CHALLENGE_NONE = "CHALLENGE_NONE";
export const CHALLENGE_SELECT_WORKSPACE = "CHALLENGE_SELECT_WORKSPACE";
export const CHALLENGE_SHOW_PROVISIONING_PAGE =
  "CHALLENGE_SHOW_PROVISIONING_PAGE";
export const CHALLENGE_SETUP_WORKSPACE = "CHALLENGE_SETUP_WORKSPACE";

const defaultFteConfig = {
  decimal: 2,
  currencySymbol: "$",
};

const useWorkspaceContext = (props) => {
  const {
    challenge,
    workspace,
    tenantOrgConfig,
    error,
    workspaces,
    isWorkspaceDataLoading,
    isReportingResourceProvisioned,
    reloadCurrentWorkspace,
  } = props;

  const effectiveLocale =
    get(workspace, "config.locale") ||
    get(tenantOrgConfig, "locale") ||
    "en-AU";

  useEffect(() => {
    if (i18next.isInitialized) {
      i18next.changeLanguage(effectiveLocale).catch(() => {});
    }
  }, [effectiveLocale]);

  return {
    challenge,
    workspace,
    tenantOrgConfig,
    error,
    workspaces,
    isWorkspaceDataLoading,
    isReportingResourceProvisioned,
    reloadCurrentWorkspace,
  };
};

const [
  Provider,
  useIsWorkspaceLoading,
  useWorkspaceError,
  useWorkspaceChallenge,
  useWorkspace,
  useWorkspaces,
  useCheckReportingResourceProvisioned,
  useReloadCurrentWorkspace,

  // Deep selectors
  useGroupTypes,
  useAllocationConfig,
  useTagTypes,
  useWorkspaceTagConfig,
  useWorkspaceUnfilteredTagConfig,
  useWorkspaceDemandRequestConfig,
  useWorkspaceFeatureFlags,
  useWorkspaceFteConfig,
  useWorkspaceLocale,
  useTenantOrgConfig,
] = constate(
  useWorkspaceContext,
  (value) => value.isWorkspaceDataLoading,
  (value) => value.error,
  (value) => value.challenge,
  (value) => value.workspace,
  (value) => value.workspaces,
  (value) => value.isReportingResourceProvisioned,
  (value) => value.reloadCurrentWorkspace,

  // Deep selectors
  (value) => get(value, "workspace.config.groupTypes"),
  (value) => get(value, "workspace.config.allocation", {}),
  (value) => get(value, "workspace.config.tagTypes"),
  (value) => get(value, "workspace.config.tagConfig"),
  (value) => get(value, "workspace.config.unfilteredTagConfig"),
  (value) => get(value, "workspace.config.demandRequest"),
  (value) => get(value, "workspace.config.featureFlags", {}),
  (value) => get(value, "workspace.config.fteConfig", defaultFteConfig),
  (value) =>
    get(value, "workspace.config.locale") ||
    get(value, "tenantOrgConfig.locale") ||
    "en-AU",
  (value) => value.tenantOrgConfig
);

export {
  Provider,
  useIsWorkspaceLoading,
  useWorkspaceError,
  useWorkspaceChallenge,
  useWorkspace,
  useWorkspaces,
  useCheckReportingResourceProvisioned,
  useReloadCurrentWorkspace,
  useGroupTypes,
  useAllocationConfig,
  useTagTypes,
  useWorkspaceTagConfig,
  useWorkspaceUnfilteredTagConfig,
  useWorkspaceDemandRequestConfig,
  useWorkspaceFeatureFlags,
  useWorkspaceFteConfig,
  useWorkspaceLocale,
  useTenantOrgConfig,
};
